import React from 'react';
import { Descriptions, Space, Popover, Typography } from 'antd';
import { LeftOutlined, InfoCircleOutlined } from '@ant-design/icons';
import get from 'lodash/get';

const { Text } = Typography;
const BrandInfo = (props) => {
  const { onClose, brand } = props;

  return (
    <>
      <div className="heading">
        <LeftOutlined
          className="back-btn"
          onClick={() => {
            onClose();
          }}
        />
        Brands Details
      </div>
      <div className="product-final-confirmation-container mt-30">
        <Descriptions bordered column={1} size="large">
          <Descriptions.Item label="Name">
            {get(brand, 'name')}
          </Descriptions.Item>
          <Descriptions.Item label="Total Product ">
            {get(brand, 'product_count')}
          </Descriptions.Item>
          <Descriptions.Item label="Type">
            {get(brand, 'product_type')}
          </Descriptions.Item>
          <Descriptions.Item label="User">
            <Space size="large">
              {get(brand, 'user_count')}
              <Popover
                content={
                  <>
                    <div>
                      <Space size="large">
                        <Text strong>Admin : </Text>
                        <Text type="secondary">
                          {get(brand, 'admin_count')}
                        </Text>
                      </Space>
                    </div>
                    <div>
                      <Space size="large">
                        <Text strong>Manager : </Text>
                        <Text type="secondary">
                          {get(brand, 'manager_count')}
                        </Text>
                      </Space>
                    </div>
                  </>
                }
                title={`Users (${get(brand, 'user_count')})`}
              >
                <InfoCircleOutlined />
              </Popover>
            </Space>
          </Descriptions.Item>
        </Descriptions>
      </div>
    </>
  );
};

export default BrandInfo;
